"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _regenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _PersonalizedConfiguration = _interopRequireDefault(require("./PersonalizedConfiguration.vue"));
var _withdrawalManagement = require("@/api/financialManagement/withdrawalManagement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Index',
  components: {
    PersonalizedConfiguration: _PersonalizedConfiguration.default
  },
  data: function data() {
    return {
      activeName: 'first',
      ruleForm: {
        withdrawSwitch: true,
        // 开关
        tips: '',
        billStatsDay: '',
        withdrawCountAccount: '',
        withdrawCountUser: '',
        amountLimit: '',
        amountMultipleLimit: '',
        amountLimitTeam: '',
        amountMultipleLimitTeam: '',
        feeAmountTeam: '',
        realNameAmount: '',
        autoGive: true,
        // 是否自动打款
        autoGiveFirstLimit: true,
        autoGiveTimeLimit: true,
        startTime: '',
        endTime: '',
        autoGiveAmountLimit: '',
        commissionX: '',
        commissionY: '',
        expireX: '',
        withdrawX: ''
      },
      rules: {
        withdrawSwitch: [{
          required: true,
          message: '请选择是否开启',
          trigger: 'change'
        }],
        tips: [{
          required: true,
          message: '请输入关闭提醒',
          trigger: 'blur'
        }],
        billStatsDay: [{
          required: true,
          message: '请输入月结账单日',
          trigger: 'blur'
        }],
        withdrawCountAccount: [{
          required: true,
          message: '请输入次数限制',
          trigger: 'blur'
        }],
        withdrawCountUser: [{
          required: true,
          message: '请输入同一个账号每天最多申请提现次数',
          trigger: 'blur'
        }],
        amountLimit: [{
          required: true,
          message: '请输入单笔最低提现金额',
          trigger: 'blur'
        }],
        amountMultipleLimit: [{
          required: true,
          message: '请输入单笔提现金额倍数限制',
          trigger: 'blur'
        }],
        amountLimitTeam: [{
          required: true,
          message: '请输入单笔最低提现金额',
          trigger: 'blur'
        }],
        amountMultipleLimitTeam: [{
          required: true,
          message: '请输入单笔提现金额倍数限制',
          trigger: 'blur'
        }],
        feeAmountTeam: [{
          required: true,
          message: '请输入提现手续费',
          trigger: 'blur'
        }],
        realNameAmount: [{
          required: true,
          message: '请输入认证金额限制',
          trigger: 'blur'
        }],
        autoGive: [{
          required: true,
          message: '请选择是否开启',
          trigger: 'change'
        }],
        autoGiveFirstLimit: [{
          required: true,
          message: '请选择是否开启',
          trigger: 'change'
        }],
        autoGiveTimeLimit: [{
          required: true,
          message: '自动打款时间限制',
          trigger: 'change'
        }],
        autoGiveAmountLimit: [{
          required: true,
          message: '请输入提现金额大于X（元）不自动打款',
          trigger: 'blur'
        }],
        commissionX: [{
          required: true,
          message: '60天内商品佣金比例大于 x%，占总订单数量比例大于y% ，不自动打款',
          trigger: 'blur'
        }],
        commissionY: [{
          required: true,
          message: '60天内商品佣金比例大于 x%，占总订单数量比例大于y% ，不自动打款',
          trigger: 'blur'
        }],
        expireX: [{
          required: true,
          message: '近60天内失效订单占比大于x% 不自动打款',
          trigger: 'blur'
        }],
        withdrawX: [{
          required: true,
          message: '请输入具体比例（x值）',
          trigger: 'blur'
        }],
        startTime: [
        // { type: 'date', required: true, message: '请选择日期', trigger: 'change' }
        {
          required: true,
          message: '请选择日期',
          trigger: 'blur'
        }],
        endTime: [{
          required: true,
          message: '请选择日期',
          trigger: 'blur'
        }
        // { type: 'date', required: true, message: '请选择时间', trigger: 'change' }
        ]
      }
    };
  },
  created: function created() {
    this.queryWithdrawRule();
  },
  methods: {
    handleKeyDown: function handleKeyDown(e) {
      // 允许: 数字、退格、删除、Tab、左右箭头
      if (!(e.keyCode >= 48 && e.keyCode <= 57 ||
      // 数字键
      e.keyCode >= 96 && e.keyCode <= 105 ||
      // 小键盘数字
      e.keyCode === 8 ||
      // 退格
      e.keyCode === 9 ||
      // Tab
      e.keyCode === 37 ||
      // 左箭头
      e.keyCode === 39 ||
      // 右箭头
      e.keyCode === 46) // 删除
      ) {
        e.preventDefault();
      }
    },
    handleClick: function handleClick() {},
    submitForm: function submitForm(formName) {
      var _this = this;
      if (this.ruleForm.amountLimitTeam < this.ruleForm.feeAmountTeam || this.ruleForm.amountLimitTeam === this.ruleForm.feeAmountTeam) {
        this.$message({
          showClose: true,
          message: '团队账户单笔最低提现金额需要大于提现手续费',
          type: 'warning',
          duration: 4000
        });
        return;
      }
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this.$confirm('是否确认修改规则配置?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            _this.updateWithdrawRule();
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm: function resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    onInit: function onInit() {
      this.ruleForm = {
        withdrawSwitch: true,
        // 开关
        tips: '',
        billStatsDay: '',
        withdrawCountAccount: '',
        withdrawCountUser: '',
        amountLimit: '',
        amountMultipleLimit: '',
        amountLimitTeam: '',
        amountMultipleLimitTeam: '',
        feeAmountTeam: '',
        realNameAmount: '',
        autoGive: true,
        // 是否自动打款
        autoGiveFirstLimit: true,
        autoGiveTimeLimit: true,
        startTime: '',
        endTime: '',
        autoGiveAmountLimit: '',
        commissionX: '',
        commissionY: '',
        expireX: '',
        withdrawX: ''
      };
    },
    queryWithdrawRule: function () {
      var _queryWithdrawRule2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var params, res, _t;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              params = {};
              _context.n = 1;
              return (0, _withdrawalManagement.queryWithdrawRule)(params);
            case 1:
              res = _context.v;
              // console.log(res)
              if (res.code === 0) {
                this.ruleForm = res.data;
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              console.log(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function queryWithdrawRule() {
        return _queryWithdrawRule2.apply(this, arguments);
      }
      return queryWithdrawRule;
    }(),
    updateWithdrawRule: function () {
      var _updateWithdrawRule2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        var params, res, _t2;
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              params = (0, _objectSpread2.default)({}, this.ruleForm);
              _context2.n = 1;
              return (0, _withdrawalManagement.updateWithdrawRule)(params);
            case 1:
              res = _context2.v;
              // console.log(res)
              if (res.code === 0) {
                this.$notify.success({
                  title: '温馨提示',
                  message: '操作成功'
                });
                this.queryWithdrawRule();
              }
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              console.log(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function updateWithdrawRule() {
        return _updateWithdrawRule2.apply(this, arguments);
      }
      return updateWithdrawRule;
    }()
  }
};